/*global BMS*/
import localizationDictionary from '../localization';
import {GOLD, JPY, MAD, RSD, SILVER, TRY, XXX, COP, KES, GHS, NGN, SEK} from '../constants/identifiers';

/**
 * @param {string} stringReference - string to look for in the localizations dictionary
 * @param {object} store - lastest store info to retrieve system language
 * @param {String[]=} wildCards - used to replace wildcards on
 *
 * @returns {string}
 */
export function getText(stringReference, store, wildCards = [], systemLanguage) {

    if (store !== undefined && store !== null) {
        systemLanguage = store.getState().vpp.systemLanguage;
    }
    systemLanguage = systemLanguage.replace('-', '_');

    let overrideText = getTextOverride(stringReference, systemLanguage);
    let result = (overrideText) ? overrideText : localizationDictionary[systemLanguage][stringReference] || `STRING ${stringReference} NOT FOUND`;

    if (wildCards && wildCards.length > 0) {
        result = result.replace(/\{(\d+)\}/g, function (match, num) {
            return wildCards[num];
        });

    }

    return result;
}

function getTextOverride(stringReference, systemLanguage) {
    if (process.env.NODE_ENV !== 'development' && BMS && BMS.Localization && BMS.Localization.overrides && BMS.Localization.overrides[systemLanguage]) {
        return BMS.Localization.overrides[systemLanguage][stringReference];
    } else {
        return undefined;
    }
}

export function getFormattedCurrency(
    store,
    value,
    fractionDigitsCount = 2,
    systemLanguage,
    systemCurrency,
    includeCurrencySymbol = true
) {

    if (store !== undefined && store !== null) {
        systemLanguage = store.getState().vpp.systemLanguage;
        systemCurrency = store.getState().vpp.systemCurrency;
    }

    if (usingNonDecimalCurrency(systemCurrency)) {
        if (value !== undefined && typeof value === 'string' &&
            (value.indexOf('/') > -1 || value.indexOf('.') !== -1) ||
            (('' + value).indexOf('.') !== -1)) {
            return value;
        }
    } else {
        if (value !== undefined && typeof value === 'string' && value.indexOf('/') > -1) {
            return value;
        }
    }

    let formattedValue = 0;
    if (value !== undefined && !isNaN(value)) {
        formattedValue = Number(value);
        if (formattedValue < 1) {
            /* if the value is cents, decimal places must be forced otherwise,
            to locale string rounds the number to the next integer */
            fractionDigitsCount = 2;
        }
    }

    if (usingNonDecimalCurrency(systemCurrency)) {
        if (systemCurrency === GOLD || systemCurrency === SILVER || systemCurrency === JPY) {
            fractionDigitsCount = 0;
        } else {
            fractionDigitsCount = 2;
            formattedValue = formattedValue / 100;
        }
    }

    let options;
    let requiredFormatting = false;
    if (systemCurrency.toUpperCase() === XXX) {
        includeCurrencySymbol = false;
        requiredFormatting = true;
    }

    if (includeCurrencySymbol) {
        options = {
            style: 'currency',
            currencyDisplay: 'symbol',
            localeMatcher: 'lookup',
            currency: systemCurrency,
            minimumFractionDigits: fractionDigitsCount,
            maximumFractionDigits: fractionDigitsCount
        }
    } else {
        options = {
            minimumFractionDigits: fractionDigitsCount,
            maximumFractionDigits: fractionDigitsCount,
            useGrouping: false
        }
    }

    if (systemCurrency.toUpperCase() === XXX) {
        options["useGrouping"] = true;
        formattedValue = formattedValue.toLocaleString(systemLanguage.replace('_', '-'), options);
    } else {
        formattedValue = formattedValue.toLocaleString(systemLanguage.replace('_', '-'), options);
    }

    if (systemCurrency.toUpperCase() === TRY) {
        let trySymbol = formattedValue.replace(/[0-9,.]/g, '').trim();
        formattedValue = formattedValue.replace(trySymbol, '') + trySymbol;
    }

    // remove potential letters added as currency symbol i.e. CA$ or US$ or AU$
    if ((includeCurrencySymbol || requiredFormatting) && systemCurrency.toUpperCase() !== RSD 
            && systemCurrency.toUpperCase() !== COP && systemCurrency.toUpperCase() !== KES 
            && systemCurrency.toUpperCase() !== NGN && systemCurrency.toUpperCase() !== GHS
            && systemCurrency.toUpperCase() !== SEK ) {

        formattedValue = formattedValue.replace(/[a-zA-Z]+/g, "");
        formattedValue = formattedValue.replace(String.fromCharCode(160), '');
    }

    //VPPIN-1697 - special case for currency MAD, below code is to replace default currency symbol.
    if (includeCurrencySymbol && systemCurrency.toUpperCase() === MAD )
        formattedValue = getText(systemCurrency.toUpperCase(), store, [formattedValue]);

    return formattedValue;
}


export function usingNonDecimalCurrency(systemCurrency) {
    return systemCurrency === GOLD || systemCurrency === SILVER || systemCurrency == JPY;
}

export function getDecimalSeparator(store) {
    if (store !== undefined && store !== null) {
        let systemLanguage = store.getState().vpp.systemLanguage;
        let formattedValue = 1.1;
        let options = {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: false
        }
        formattedValue = formattedValue.toLocaleString(systemLanguage.replace('_', '-'), options);
        if (formattedValue.indexOf(",") > -1)
            return ","
        else
            return "."
    }
}

export function getDecimalSeparatorFromLanguage(systemLanguage) {
    if (systemLanguage !== undefined && systemLanguage !== null) {
        let formattedValue = 1.1;
        let options = {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: false
        }
        formattedValue = formattedValue.toLocaleString(systemLanguage.replace('_', '-'), options);
        if (formattedValue.indexOf(",") > -1)
            return ","
        else
            return "."
    }
}

export function getformattedNumber(store, value, minimumFractionDigits) {
    let formattedValue;
    if (store !== undefined && store !== null) {
        let systemLanguage = store.getState().vpp.systemLanguage;
        let options = {
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: 2,
            useGrouping: false
        }
        formattedValue = Number(value).toLocaleString(systemLanguage.replace('_', '-'), options);
    }
    return formattedValue;
}

export function reverseFormatNumber(val, locale) {
    var decimal = new Intl.NumberFormat(locale.replace('_', '-')).format(1.1).replace(/1/g, '');
    var reversedVal = val.replace(new RegExp('\\' + decimal, 'g'), '.');
    return Number.isNaN(reversedVal) ? 0 : reversedVal;
}



// WEBPACK FOOTER //
// ./src/helpers/localization.js